import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1661312957377'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='16247'
    >
        <path
            d='M912 329.493333h-149.333333a5.333333 5.333333 0 0 1-5.333334-5.333333V112a5.333333 5.333333 0 0 0-5.333333-5.333333H112a5.333333 5.333333 0 0 0-5.333333 5.333333v800a5.333333 5.333333 0 0 0 5.333333 5.333333h714.666667a90.666667 90.666667 0 0 0 90.666666-90.666666V334.826667a5.333333 5.333333 0 0 0-5.333333-5.333334zM682.666667 837.333333a5.333333 5.333333 0 0 1-5.333334 5.333334H186.666667a5.333333 5.333333 0 0 1-5.333334-5.333334V186.666667a5.333333 5.333333 0 0 1 5.333334-5.333334h490.666666a5.333333 5.333333 0 0 1 5.333334 5.333334z m160-37.333333a42.666667 42.666667 0 0 1-42.666667 42.666667 42.666667 42.666667 0 0 1-42.666667-42.666667V409.493333a5.333333 5.333333 0 0 1 5.333334-5.333333h74.666666a5.333333 5.333333 0 0 1 5.333334 5.333333z'
            p-id='16248'
            fill='currentColor'
        ></path>
        <path
            d='M258.186667 564.106667m5.333333 0l336.96 0q5.333333 0 5.333333 5.333333l0 64q0 5.333333-5.333333 5.333333l-336.96 0q-5.333333 0-5.333333-5.333333l0-64q0-5.333333 5.333333-5.333333Z'
            p-id='16249'
            fill='currentColor'
        ></path>
        <path
            d='M258.186667 686.453333m5.333333 0l336.96 0q5.333333 0 5.333333 5.333334l0 64q0 5.333333-5.333333 5.333333l-336.96 0q-5.333333 0-5.333333-5.333333l0-64q0-5.333333 5.333333-5.333334Z'
            p-id='16250'
            fill='currentColor'
        ></path>
        <path
            d='M335.413333 481.493333a5.333333 5.333333 0 0 0 5.333334 4.16H394.666667a5.333333 5.333333 0 0 0 5.333333-3.893333l33.92-122.24a1.066667 1.066667 0 0 1 2.026667 0l34.08 122.24a5.333333 5.333333 0 0 0 5.333333 3.893333h53.813333a5.333333 5.333333 0 0 0 5.333334-4.16l43.093333-195.52a5.333333 5.333333 0 0 0-5.333333-6.453333h-49.173334a5.333333 5.333333 0 0 0-5.333333 4.32l-20.106667 106.666667a1.066667 1.066667 0 0 1-2.08 0l-29.546666-107.093334a5.333333 5.333333 0 0 0-5.333334-3.893333h-52a5.333333 5.333333 0 0 0-5.333333 3.893333l-29.386667 107.146667a1.013333 1.013333 0 0 1-2.026666 0L352 283.84a5.333333 5.333333 0 0 0-5.333333-4.32h-49.546667a5.333333 5.333333 0 0 0-5.333333 6.453333z'
            p-id='16251'
            fill='currentColor'
        ></path>
    </svg>
)

export const WeeklyIcon = props => <Icon component={SVG} {...props} />
